import {GlobalSearchResultEntry} from "./global-search-result-entry";

export class GlobalSearchResult {
  label: string;
  icon: string;
  description: string;
  entries: GlobalSearchResultEntry[];
}
